import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';

export const LoadingButton = ({ loading, onClick, size = 'small', children, className, disabled }) => (
	<Button variant='contained' onClick={onClick} className={className} size={size} disabled={disabled}>
		{loading && <CircularProgress size={20} />}
		{!loading && children}
	</Button>
);
